import { ReactNode } from "react"
import { useForm, usePage, Link } from '@inertiajs/react'
import { Button } from "../components/ui/button"
import { LogOut, LayoutDashboard, FileText, FolderOpen, Mail } from "lucide-react"
import FlashMessages from "../components/FlashMessages"
import { cn } from "../utils/cn"

interface AdminLayoutProps {
  children: ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  const { delete: destroy, processing } = useForm()
  const { url } = usePage()

  const navItems = [
    { href: "/admin", label: "Dashboard", icon: LayoutDashboard },
    { href: "/admin/blog_posts", label: "Blog Posts", icon: FileText },
    { href: "/admin/projects", label: "Projects", icon: FolderOpen },
    { href: "/admin/newsletter_subscribers", label: "Newsletter Subscribers", icon: Mail },
  ]

  const handleLogout = () => {
    destroy('/admin/session')
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-6">
            <h1 className="text-2xl font-bold">Admin</h1>
            <nav className="flex space-x-4">
              {navItems.map((item) => {
                const Icon = item.icon
                const isActive = url === item.href || (item.href !== "/admin" && url.startsWith(item.href))
                return (
                  <Link
                    key={item.href}
                    href={item.href}
                    className={cn(
                      "flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors",
                      isActive
                        ? "bg-primary text-primary-foreground"
                        : "text-muted-foreground hover:text-foreground hover:bg-muted"
                    )}
                  >
                    <Icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </Link>
                )
              })}
            </nav>
          </div>
          <Button variant="outline" onClick={handleLogout} disabled={processing}>
            <LogOut className="h-4 w-4 mr-2" />
            Logout
          </Button>
        </div>
      </header>

      <FlashMessages />

      <main className="container mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  )
}

export default AdminLayout 